import React, { useState} from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import InputGroup from "react-bootstrap/InputGroup"
import { Text } from "components/Form"
import { Popup } from "components"

import "./index.scss"

import { FiPlus, FiSettings } from "react-icons/fi"

import { chooseOptimalColor } from "utils/scripts/schedule"
import { AnalysisGroupConfig } from "components/Config"
import { Button } from "react-bootstrap"
import { analysisGroups } from "state_management"
import useT from "utils/hooks/useT"


export default function AnalysisTab() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useT("common")
  const analysisDefinitions = useSelector((state) => state.analysisDefinitions)
  const [filterString, setFilterString] = useState("")
  const [showGroupSettings, setShowGroupSettings] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const localAnalysisGroups = useSelector((state) => state.analysisGroups.groups)
  const analysisGroupsSorted = Object.values(localAnalysisGroups).sort((a, b) => {
    if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
    if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
    return 0
  })

  if (!analysisDefinitions) {
    return <div />
  }

  const filteredAnalysisDefinitions = Object.values(analysisDefinitions).filter((analysis) => {
    return analysis.name.toUpperCase().includes(filterString.toUpperCase())
  })

  return (
    <div className="AnalysisTab-main-container">
      {showGroupSettings && (
        dispatch(analysisGroups.fetchTasks(selectedGroup.id)),
        <Popup onCancel={() => setShowGroupSettings(false)}>
          <AnalysisGroupConfig
            analysisGroup={selectedGroup}
            isBundleSettings={true}
            onClose={() => {
              setShowGroupSettings(false)
              setSelectedGroup(null)
            }}
            onSubmit={() => {
              setShowGroupSettings(false)
              setSelectedGroup(null)
            }}
          />
        </Popup>
      )}
      {Object.keys(analysisDefinitions).length > 0 && ( // Only display filter if the team has analyses
        <div className="AnalysisTab-filter">
          <InputGroup className="AssetView-filter-input-field">
            <Text placeholder={t("filterByName")} value={filterString} onChange={setFilterString} />
          </InputGroup>
          <Button className="AnalysisTab-add-button" onClick={() => navigate(`/setup/analyses/create`)}>
            {t("addAnalysis")}
          </Button>
        </div>
      )}
      {analysisGroupsSorted.map((group) => (
        <React.Fragment key={group.id}>
          <div className="AnalysisGroupName-container">
            <h3>{group.name}</h3>
            <FiSettings className="groupSettings" title={t("editGroup")} onClick={() => {
                dispatch(analysisGroups.fetchBundles(group.id));
                setShowGroupSettings(true);
                setSelectedGroup(group);
              }} />
          </div>
          <div className="AnalysisTab-analyses-container">
            {filteredAnalysisDefinitions.map((analysisDefinition) => {
              return (
                analysisDefinition.analysisGroupIds.includes(group.id) && (
                  <div
                    key={analysisDefinition.id}
                    className={"AnalysisTab-analysis-container AnalysisTab-hovereffect" + (analysisDefinition.isDraft ? " AnalysisDraft-withBorder" : "")
                    }
                    style={{
                      backgroundColor: analysisDefinition.color,
                      color: chooseOptimalColor(analysisDefinition.color),
                    }}
                    onClick={() => navigate(`/setup/analyses/${analysisDefinition.id}`)}
                  >
                    <p>{analysisDefinition.name}</p>
                  </div>
                )
              )
            })}
          </div>
        </React.Fragment>
      ))}
      {analysisGroupsSorted.length !== 0 && <div className="AnalysisGroupName-container">
        <h3>{t("noGroup")}</h3>
      </div>}
      <div className="AnalysisTab-analyses-container">
          {filteredAnalysisDefinitions.map((analysisDefinition) => {
            return analysisDefinition.analysisGroupIds.length === 0 && (
            <div
              key={analysisDefinition.id}
              className={"AnalysisTab-analysis-container AnalysisTab-hovereffect" + (analysisDefinition.isDraft ? " AnalysisDraft-withBorder" : "")}
              style={{
                backgroundColor: analysisDefinition.color,
                color: chooseOptimalColor(analysisDefinition.color),
              }}
              onClick={() => navigate(`/setup/analyses/${analysisDefinition.id}`)}
            >
              <p>{analysisDefinition.name}</p>
            </div>
          )
        })}
        <div className="AnalysisTab-analysis-container">
          <FiPlus title={t("addAnalysis")} onClick={() => navigate(`/setup/analyses/create`)} />
        </div>
      </div>
    </div>
  )
}
